import React, {Component, Fragment} from "react";
import PageHeaderLayout from "../../layout/PageHeaderLayout";
import {Button, Card, Divider, message, Popconfirm} from "antd";
import StandardTable from "../../components/StandardTable";
import authWrapper from "../../utils/authWrapper";
import FormModal from "../../components/FormModal";
import * as api from "../../api/employee";

const AddButton = authWrapper('add')(Button);
const EditFragment = authWrapper('edit')(Fragment);
const DeletePopconfirm = authWrapper('delete')(Popconfirm);

const modifyFields = [
    {
        dataIndex: 'id',
        visible: false
    },
    {
        title: '工号',
        dataIndex: 'employee_no',
        rules: [{
            required: true, message: '请输入工号',
        }],
    },
    {
        title: '姓名',
        dataIndex: 'name',
        rules: [{
            required: true, message: '请输入姓名',
        }],
    },
    {
        title: '位置',
        dataIndex: 'position',
    }
];

class Employee extends Component {

    state = {
        modalVisible: false,
        modalSaving: false,
        modalRecord: {},
    }

    columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            width: 100
        },
        {
            title: '工号',
            dataIndex: 'employee_no',
        },
        {
            title: '姓名',
            dataIndex: 'name',
        },
        {
            title: '位置',
            dataIndex: 'position',
        },
        {
            title: '操作',
            render: (record) => {
                return (
                    <span>
                    <EditFragment>
                        <a onClick={() => this.handleModalShow(record)}>编辑</a>
                        <Divider type="vertical"/>
                    </EditFragment>
                    <DeletePopconfirm title="是否确认删除?" onConfirm={() => {
                        this.handleDelete(record.id)
                    }}>
                        <a>删除</a>
                    </DeletePopconfirm>
                </span>
                )
            }
        }
    ]

    handleModalShow = (record = {}) => {
        this.setState({
            modalVisible: true,
            modalRecord: record,
        })
    };

    handleModalOk = (fieldsValue) => {
        this.setState({
            modalSaving: true,
        });
        api.modifyEmployee({...fieldsValue}).then(() => {
            this.setState({
                modalSaving: false,
                modalVisible: false
            });
            this.dataTable.fetch()
        }).catch(() => {
            this.setState({
                modalSaving: false,
            });
        })
    };

    handleDelete = (employeeId) => {
        api.deleteEmployee(employeeId).then(() => {
            this.dataTable.fetch();
            message.success('删除成功')
        })
    };

    render() {
        return (
            <PageHeaderLayout title={'员工管理'}>
                <Card>
                    <div style={{marginBottom: 15}}>
                        <AddButton type={'primary'} onClick={() => this.handleModalShow()}>新增</AddButton>
                    </div>
                    <StandardTable columns={this.columns}
                                   rowKey={'id'}
                                   url={'/api/employee'}
                                   ref={(table) => this.dataTable = table}
                    />
                </Card>
                <FormModal visible={this.state.modalVisible}
                           confirmLoading={this.state.modalSaving}
                           record={this.state.modalRecord}
                           fields={modifyFields}
                           onOk={this.handleModalOk}
                           onCancel={() => this.setState({modalVisible: false})}
                />
            </PageHeaderLayout>
        );
    }
}

export default Employee;
